module.exports = __webpack_public_path__ + "static/media/domain_logo_Indonesia.c86166c0.svg";